import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			//首页
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			//首页
			path: '/contact',
			name: 'contact',
			component: (resolve) => require(['@/views/contact.vue'], resolve),
		},
		{
			//首页
			path: '/about',
			name: 'about',
			component: (resolve) => require(['@/views/about.vue'], resolve),
		},
		{
			//首页
			path: '/services',
			name: 'services',
			component: (resolve) => require(['@/views/services.vue'], resolve),
		},
		{
			//产品页面
			path: '/products',
			name: 'products',
			component: (resolve) => require(['@/views/products.vue'], resolve),
		},
		{
			path: '/limitbee',
			name: 'limitbee',
			component: (resolve) => require(['@/views/limitbee.vue'], resolve),
		},
		//cooperate
	],
})
